import Card, { CardProps } from "./components/Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import SwiperNavigation from "../SwiperNavigation";

const concretoTypes: CardProps[] = [
  {
    title: "Hamburguesas",
    description:
      "Recetas originales con almenra nuez, portobello y muchas más.",
    image: "/vegan/productos/productos.webp",
  },
  {
    title: "Quesos",
    description:
      "Prueba nuestros maravillosos quesos veganos, desde la receta natural hasta marinados y/o preparados.",
    image: "/vegan/productos/almendra_quesos.webp",
  },
  {
    title: "Tofu",
    description:
      "Nuestra variedad de tofu te va sorprender, prueba nuestro tofu original de garbanzo con pesto. asdhbfsajhfba asdkfasfkjsna askfjnaskfjna aksdfnasjkdf ...........",
    image: "/vegan/productos/chickpea_tofu.webp",
  },
  {
    title: "Chorizo vegano",
    description:
      "Nuestra variedad de tofu te va sorprender, prueba nuestro tofu original de garbanzo con pesto.",
    image: "/vegan/productos/almendra_chorizo.webp",
  },
  {
    title: "Buffets",
    description:
      "Nuestra variedad de tofu te va sorprender, prueba nuestro tofu original de garbanzo con pesto.",
    image: "/vegan/productos/buffet.webp",
  },
  {
    title: "Paquetes de comida ",
    description:
      "Nuestra variedad de tofu te uestro tofu original de garbanzo con pesto.",
    image: "/vegan/productos/paquete.webp",
  },
];

export default function Carrousel() {
  return (
    <div className="container md:px-6 pb-3 overflow-x-hidden">

      <div className="relative w-full mx-auto md:max-w-full ">
        
        <h2 className="place-self-center text-primary my-4">Nuestros productos y servicios</h2>
        <Swiper
          modules={[Pagination, Navigation, Autoplay]}
          autoplay={{ delay: 2500 }}
          loop={true}
          centeredSlides={true}
          pagination={{
            el: ".swiper-pagination",
            clickable: true,
            type: "bullets",
            bulletElement: "button",
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
          }}
          breakpoints={{
            // cuando el ancho de la ventana es >= 640px
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
              centeredSlides: true,
            },
            // cuando el ancho de la ventana es >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
              centeredSlides: true,
            },
            // cuando el ancho de la ventana es >= 1024px
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
              centeredSlides: true,
            },
          }}
        >
          {concretoTypes.map((concretoType, index) => (
            <SwiperSlide key={index} className="flex h-full">
              <Card {...concretoType} />
            </SwiperSlide>
          ))}
          <SwiperNavigation />
        </Swiper>
      </div>

    </div>
  );
}
